import {html} from "./utils/environment";

import hamburger from "./components/hamburger";
import tab from "./components/tab";
import card from "./components/card";
import slider from "./components/slider";
import lightbox from "./components/lightbox";

// Il foglio di stile e' render-blocking, quindi a window.onload e' gia' applicato.
window.onload = () => {
    init();
};

function init() {
    console.log("App JS Started");

    html.classList.add("is-loaded");
    html.classList.add("is-ready");
    html.classList.remove("is-loading");

    tab();
    card();
    hamburger();
    slider();
    lightbox();
}


